import React, { useContext, useRef, useState, useEffect } from 'react';
import AXIOS from 'axios';
import { useNavigate } from 'react-router-dom';
import fileSize from 'filesize';
import useSWR from 'swr';
import Lottie from 'react-lottie';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
import Spinner from 'Components/Spinner';
import AWS from 'aws-sdk';
import {
  DialogContent,
  DialogTitle,
  Fade,
  FormControlLabel,
  RadioGroup,
  makeStyles,
  withStyles,
  CircularProgress,
} from '@material-ui/core';
import { AppContext } from 'Context';
import { Pathname } from 'Routes';
import {
  dataFetcher,
  endpoints,
  AxiosCancelToken,
  baseUrl,
  firebaseCredentials,
  axios,
} from 'Api';
import { CloudUploadOutlined } from '@material-ui/icons';
import { ref, update, getDatabase, off, onValue } from 'firebase/database';
import { initializeApp } from 'firebase/app';
import { useDispatch, useSelector } from 'react-redux';
import {
  addS3VideoDraftContent,
  addVideoDraftContent,
  addVideo,
} from 'Api/apiFunctions';
import {
  saveUploadInfo,
  saveUploadSizes,
  saveDummy,
  removeDummy,
  setAddVideo,
} from 'store/store';

import addFileImage from 'Assets/add-file@2x.png';
import noPhotoAvailable from 'Assets/no-image-available.png';
import generatingThumbnail from 'Assets/generating-thumbnail.jpg';
import { ReactComponent as CloseIcon } from 'Assets/close.svg';
import { ReactComponent as BackIcon } from 'Assets/chevron-left.svg';
import { awsConfig, generateS3Url, getBucketName, getBucketNamePath } from '../../Api/awsConfig';
// import VideoUploaded from 'Assets/video-uploaded.json';
import { GroupSelector } from '../group-selector';
import { Button } from '../button';
import { Text } from '../text';
import ChooseWhatUpload from './components/ChooseWhatUpload';
import VideoSelect from './components/SelectVideo';
import PhotoSelect from './components/SelectPhoto';
import { Radio, DialogFooter } from './components/Material-reDesign';
import ProgressTracker from './components/ProgressTracker';
import { ContentBox, ContentBoxSection } from './components/ContentBox';
import VideoPreview from './components/VideoPreview';
import PhotoPreview from './components/PhotoPreview';
import InputField from './components/InputField';
import ChooseAlbum from './components/ChooseAlbum';
import AlbumDetails from './components/AlbumDetails';
import AlbumSummary from './components/AlbumSummary';
import LoaderContent from './model-dialog-content/LoaderContent';
import styles from './index.module.css';
import './loader.css';
import UpdateCategoryPlaylist from './model-dialog-content/UpdateCategoryPlaylist';
// eslint-disable-next-line import/order
import useConvertHeicImages from 'hooks/useConvertHeicImages';
import VideoDetails from './components/VideoDetails';
import VideoSummary from './components/VideoSummary';
import { InfoModal } from '../../Pages/private/dashboard/info-modal';

const iteratorNum = [];
const totalNum = [];
let tempPercentages;
const formDataJsonString = [];

AWS.config.update({
  region: awsConfig.region,
  accessKeyId: awsConfig.accessKey,
  secretAccessKey: awsConfig.secretKey,
});
AWS.config.httpOptions.timeout = 0;
const s3 = new AWS.S3();

async function initMultipartUpload(bucket, key) {
  const params = {
    Bucket: bucket,
    Key: key,
  };

  return s3.createMultipartUpload(params).promise();
}

export const SAVE_TYPE = {
  DRAFT: 'draft',
  PUBLISH: 'publish',
};

const defaultVideoDetails = {
  name: undefined,
  duration: undefined,
  size: undefined,
};

const useStyles = makeStyles({
  colorPrimary: {
    background: '#5aa5ef',
  },
});

const Modal = ({
  isVisible,
  onHide,
  handleUploadModalClose: handleClose,
  // imageFiles,
}) => {
  const {
    imageFiles,
    setHoldTheWeb,
    setAppSnackbar,
    subscriptionDetails,
    setUserDetails,
    userDetails,
    langText,
    setPageLoad,
    addMorePhoto,
    setaddMorePhoto,
    isS3UploadComplete,
    setSingleUpload,
    isSinglUepload,
    startingFlowEvent,
    startFlowEvent,
    setModalVisibility,
    s3Data,
    setS3Data,
    uploadingInProgress,
    setUploadingInProgress,
    setisAddDraftDone,
    textOfUpload,
    settextOfUpload,
    firebaseDatabase,
    setUploadContainer,
    setDraftCategoryState,
    draftCategoryState,
    setFormData,
    videoGroup,
    setVideoGroup,
    setIamUploading,
    didIOpenModal,
    setUploadContainer2,
    autoSignIn,
    MAX_PHOTOS,
    navigateToInviteFirstTime,
    setTabTitle,
    uploadType,
    setUpdateType,
    MAX_VIDEOS,
    setfetchDraftID,
    setSelectedFiles,
    setTrailPopUpModalVisible,
    setS3UploadComplete,
    chooseAlbumStep,
    setChooseAlbumStep,
    MAX_SIZE_GB
  } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [autoUpload, setAutoUpload] = useState(false);
  const uploadPercentages = useSelector((state) => state.upload);
  const dispatch = useDispatch();
  const updateUploadPercentages = (draft_id, data) => {
    dispatch(saveUploadInfo({ [draft_id]: data }));
  };

  const updateUploadSizes = (draft_id, data) => {
    dispatch(saveUploadSizes({ [draft_id]: data }));
  };
  // temp add
  useEffect(() => {
    // const allPropertiesAreNumericOrString = Object.values(uploadPercentages).some((value) => typeof value === 'number' || value === 'Starting Upload' || value === 'Initializing');
    // if (allPropertiesAreNumericOrString) {
    //   setIamUploading(false);
    // } else setIamUploading(true);
    const handleBeforeUnload = (e) => {
      const allPropertiesAreNumericOrString = Object.values(
        uploadPercentages
      ).some(
        (value) => typeof value === 'number'
          || value === 'Starting Upload'
          || value === 'Initializing'
      );
      if (allPropertiesAreNumericOrString) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [uploadPercentages]);
  // temp end
  const navigate = useNavigate();
  let domain = window.location.href;
  const uploadText = langText?.upload;
  const commonText = langText?.common;
  const visibilityText = langText?.visibility;
  const videoVisibilityOptions = [
    { name: 'All Viewers', value: '2' },
    {
      name: visibilityText?.privateDescription || 'Only I can view (Private)',
      value: '1',
    },
    {
      name: visibilityText?.groupDescription || 'Choose a group to share with',
      value: '3',
    },
  ];

  // const defaultVideoVisibility = videoVisibilityOptions[0].value;
  const defaultVideoVisibility = videoVisibilityOptions[0].value;
  const fileInputRef = useRef(null);

  domain = domain?.replace(/http[s]?:\/\//, '');
  domain = domain?.split('/')[0];

  const [currentStep, setCurrentStep] = useState(undefined);
  const [defaultVideoThumbnail, setDefaultVideoThumbnail] = useState(noPhotoAvailable);
  const [thumbnailType, setThumbnailType] = useState('normal');
  const [blobFile, setBlobFile] = useState([]);

  const [videoDescription, setVideoDescription] = useState('');
  const [videoDetails, setVideoDetails] = useState(defaultVideoDetails);
  const [videoFile, setVideoFile] = useState(undefined);
  const [videoID, setVideoID] = useState(undefined);
  const [videoThumbnails, setVideoThumbnails] = useState([]);
  const [customVideoThumbnails, setCustomVideoThumbnails] = useState([]);
  const customAdded = useRef(false);
  const [videoTitle, setVideoTitle] = useState('');
  const [videoVisibility, setVideoVisibility] = useState(
    defaultVideoVisibility
  );
  const [videoIsPublished, setVideoPublishStatus] = useState(false);
  const [videoIsUploaded, setVideoUploadStatus] = useState(false);
  const [isThumbnailCreationFailed, setIsThumbnailCreationFailed] = useState(false);
  const [
    isThumbnailCreationCompleteFully,
    setIsThumbnailGenerationCompleteFully,
  ] = useState(false);
  const [videoUploadData, setVideoUploadData] = useState(undefined);
  const [fileName, setFileName] = useState('');
  // const [videoCategoryPlaylistData, setVideoCategoryPlaylistData] = useState(undefined);
  const [videoVisibilityData, setVideoVisibilityData] = useState(undefined);
  const [runLoader, setrunLoader] = useState(false);
  const [percentagee, setPercentage] = useState(0);
  const [s3VideoDetails, setS3VideoDetails] = useState({});
  const [uploadedData, setUploadedData] = useState({
    category_id: undefined,
    category_name: undefined,
    description: undefined,
    group_id: undefined,
    playlist_id: undefined,
    publish_date: undefined,
    status: undefined,
    subcategory_id: undefined,
    thumbnails: undefined,
    thumbnail_list: undefined,
    title: undefined,
    token: undefined,
    video_file: undefined,
    video_id: undefined,
    visibility: undefined,
  });

  const [videoUploadingCompleted, setVideoUploadingCompleted] = useState(false);
  const [videoUploadPercentage, setVideoUploadPercentage] = useState(0);

  const dummyObject = useSelector((state) => state.dummy);

  const [source, setSource] = useState(undefined);
  const [photoFile, setPhotoFile] = useState([]);

  const [albumTitle, setAlbumTitle] = useState('');
  const [albumDescription, setAlbumDescription] = useState('');
  const [albumThumbnails, setAlbumThumbnails] = useState([]);
  const [customAlbumThumbnails, setCustomAlbumThumbnails] = useState([]);
  const [defaultAlbumThumbnail, setDefaultAlbumThumbnail] = useState(undefined);
  const [albumUploadData, setAlbumUploadData] = useState(undefined);
  const [albumId, setAlbumId] = useState(undefined);
  const [albumVisibility, setAlbumVisibility] = useState(
    defaultVideoVisibility
  );
  const [albumGroup, setAlbumGroup] = useState([]);
  const [multiplePhoto, setMultiplePhoto] = useState(undefined);
  const [albumList, setAlbumList] = useState([]);
  const [chooseExistingAlbum, setExistingAlbum] = useState(undefined);
  const [isAnExistingAlbum, updateAnExistingAlbum] = useState(false);
  const [albumSize, setAlbumSize] = useState(undefined);
  const [albumPhotoCount, setAlbumPhotoCount] = useState(undefined);
  const [albumPublished, setAlbumPublishStatus] = useState(false);
  const [contentType, setContentType] = useState(undefined);
  const [albumStatus, setAlbumStatus] = useState(undefined);
  const [conversionStatus, setConversionStatus] = useState(0);
  const [conversionStart, setConversionStart] = useState(false);
  const [thumbnailGenerationStatus, setThumbnailGenerationStatus] = useState(false);
  const [isStorageFull, setStorageFull] = useState(false);
  const [isSelectedFile, setIsSelectedFile] = useState(false);
  const contentDashboard = langText?.contentDashboard;
  const [videoCount, setVideoCount] = useState(undefined);
  const [uniqueid, setUniqueid] = useState('');
  const [uploadChecking, setUploadChecking] = useState('');
  const [draftId, setdraftId] = useState();
  let flow;
  const classes = useStyles();
  const [images, convertingHeic] = useConvertHeicImages(photoFile);
  const [draftApiStatus, setDraftApiStatus] = useState('idle');
  const [uploadedFile, setUploadedFile] = useState();
  const [failedToGenerate, setfailedToGenerate] = useState(false);
  localStorage.setItem('percentage', percentagee);
  // end draft
  useEffect(() => {
    source?.cancel('Landing Component got unmounted');
  }, [source]);
  const blobFileRef = useRef([]);
  const totalApiFailuresRef = useRef(0);

  const addToBlobFile = (newBlob) => {
    blobFileRef.current = [...blobFileRef.current, newBlob];
    setBlobFile(blobFileRef.current);
  };
  const moveToPreviousStep = () => {
    setCurrentStep((cStep) => cStep - 1);
    // setTimeout(() => { setCurrentStep(currentStep - 1); }, 10);
  };
  const moveToNextStep = () => {
    if (currentStep + 1 <= 3) {
      setCurrentStep((cStep) => cStep + 1);
      // setTimeout(() => { setCurrentStep(currentStep + 1); }, 10);
    }
  };
  const getToken = () => localStorage.getItem('token');
  const axiosN = AXIOS.create({ baseURL: baseUrl.URL, method: 'POST' });
  axiosN.interceptors.request.use((req) => {
    if (req?.data instanceof FormData) {
      const formData = req?.data;

      if (formData.has('token')) {
        formData.delete('token');
      }

      formData.append('token', getToken());

      return { ...req, data: formData };
    }

    return { ...req, data: { ...req.data, token: getToken() } };
  });
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  const closeToast = (draft_id, message, type) => {
    toast.update(draft_id, {
      closeButton: false,
      render: message,
      type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR,
      autoClose: 3000,
    });
    setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
    setUploadContainer2((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
  };
  const deleteAdded = () => {
    // Get draft_id safely from s3Data whether it's FormData or object
    const draft_id = s3Data instanceof FormData ? s3Data.get('draft_id') : s3Data.draft_id;

    if (draft_id) {
      changeFieldFromFirebase(draft_id, 'DELETED');
      updateUploadPercentages(draftId, 'Cancelled');
      closeToast(
        draft_id,
        'Upload has been canceled by user',
        'error'
      );
    }
    setIsSelectedFile(false);
    return null;
  };

  // const dataFetcher2 = (url, data, cancelToken) => axios({
  //   url,
  //   ...data && { data },
  //   onUploadProgress: (ProgressEvent) => {
  //     const { loaded, total } = ProgressEvent;
  //     const percentage = Math.floor((loaded * 100) / total);
  //     setPercentage(percentage);
  //     if (percentage < 98) {
  //       setVideoUploadPercentage(percentage);
  //     } else {
  //       setVideoUploadPercentage(98);
  //     }
  //   },
  //   ...cancelToken && { cancelToken },

  // }).then((res) => res.data);

  const { isValidating: gettingThumbnail, mutate: getThumbnail } = useSWR(
    [endpoints.getThumbnails, videoID],
    {
      fetcher: (url, content_id) => dataFetcher(url, { content_id }),
      onSuccess: ({ success, message, videos }) => {
        if (success && videos.status) {
          if (videos?.thumbnails?.length === 0) {
            // If thumbnails array is empty, call the mutation function after 3 seconds
            setTimeout(() => {
              getThumbnail();
            }, 5000);
          } else {
            setThumbnailGenerationStatus(false);
            setVideoThumbnails([
              ...videoThumbnails,
              ...videos?.thumbnails?.slice(0, 5),
            ]);
          }
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong',
        });
      },
    }
  );

  const { isValidating: gettingConvertionStatus, mutate: getConversionStatus } = useSWR([endpoints.getVideoStatus, videoID], {
      fetcher: (url, video_id) => dataFetcher(url, { video_id }),
      onSuccess: ({ success, message, videos }) => {
        if (success) {
          setConversionStatus(videos[0].progress);
          if (videos[0].progress === 100) {
            setTimeout(() => {
              setConversionStart(false);
            }, 1000);
          }
        } else {
          // setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong' });
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong',
        });
      },
    });
  const { isValidating: uploadingVideo, mutate: uploadVideoContent } = useSWR(
    [endpoints.addVideoContent, videoUploadData, source?.token],
    {
      fetcher: (url, formData, uniqueCancelToken) => dataFetcher(url, formData, uniqueCancelToken),
      onSuccess: ({
        success,
        video_id,
        suggestedThumbnails,
        message,
        has_conversion,
      }) => {
        if (success) {
          // moveToNextStep();
          if (!videoIsUploaded) {
            // setVideoThumbnails(suggestedThumbnails);
            // setDefaultVideoThumbnail(suggestedThumbnails[0]);
            setVideoID(video_id);
            setVideoUploadStatus(true);
          }
          setThumbnailGenerationStatus(true);
          if (has_conversion) {
            setConversionStart(true);
          }
          // setTimeout(() => {
          //   getThumbnail();
          // }, 5000);
        } else {
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
        setTimeout(() => {
          setVideoUploadPercentage(videoUploadPercentage + 1);
        }, 0);
        setTimeout(() => {
          setVideoUploadPercentage(100);
        }, 500);
        setTimeout(() => {
          setVideoUploadingCompleted(true);
        }, 1000);
        setTimeout(() => {
          setrunLoader(false);
        }, 5500);
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: responseData?.message || 'Oops! Something went wrong!!',
        });
        if (responseData?.message === 'Storage Space Exceeded') {
          handleClose();
          setTimeout(() => {
            navigate(Pathname.upgradePlan);
          }, 500);
        }
        setTimeout(() => {
          setVideoUploadPercentage(videoUploadPercentage + 1);
        }, 0);
        setTimeout(() => {
          setVideoUploadPercentage(100);
        }, 500);

        setTimeout(() => {
          setVideoUploadingCompleted(true);
        }, 1000);
        setTimeout(() => {
          setrunLoader(false);
        }, 5500);
      },
    }
  );

  const { isValidating: uploadingS3Video, mutate: uploadS3Video } = useSWR(
    [endpoints.addS3VideoContent, s3Data, source?.token],
    {
      fetcher: (url, formData, uniqueCancelToken) => dataFetcher(url, formData, uniqueCancelToken),
      onSuccess: ({
        success,
        video_id,
        suggestedThumbnails,
        message,
        has_conversion,
      }) => {
        if (success) {
          // moveToNextStep();
          if (!videoIsUploaded) {
            // setVideoThumbnails(suggestedThumbnails);
            // setDefaultVideoThumbnail(suggestedThumbnails[0]);
            setVideoID(video_id);
            setVideoUploadStatus(true);
          }
          setThumbnailGenerationStatus(true);
          if (has_conversion) {
            setConversionStart(true);
          }
          // setTimeout(() => {
          //   getThumbnail();
          // }, 5000);
        } else {
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
        setTimeout(() => {
          setVideoUploadPercentage(videoUploadPercentage + 1);
        }, 0);
        setTimeout(() => {
          setVideoUploadPercentage(100);
        }, 500);
        setTimeout(() => {
          setVideoUploadingCompleted(true);
        }, 1000);
        setTimeout(() => {
          setrunLoader(false);
        }, 5500);
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: responseData?.message || 'Oops! Something went wrong!!',
        });
        if (responseData?.message === 'Storage Space Exceeded') {
          handleClose();
          setTimeout(() => {
            navigate(Pathname.upgradePlan);
          }, 500);
        }
        setTimeout(() => {
          setVideoUploadPercentage(videoUploadPercentage + 1);
        }, 0);
        setTimeout(() => {
          setVideoUploadPercentage(100);
        }, 500);

        setTimeout(() => {
          setVideoUploadingCompleted(true);
        }, 1000);
        setTimeout(() => {
          setrunLoader(false);
        }, 5500);
      },
    }
  );

  useEffect(() => {
    let interval;
    if (conversionStart) {
      interval = setInterval(() => {
        getConversionStatus();
      }, 5000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [conversionStart]);

  // useEffect(() => {
  //   let interval;
  //   if (thumbnailGenerationStatus) {
  //     interval = setInterval(() => {
  //       getThumbnail();
  //     }, 5000);
  //   } else {
  //     clearInterval(interval);
  //   }
  //   return () => clearInterval(interval);
  // }, [thumbnailGenerationStatus]);

  const { isValidating: uploadingVisibility, mutate: updateVisibilityContent } = useSWR([endpoints.addVideoContent, videoVisibilityData], {
      fetcher: (url, formData) => dataFetcher(url, formData),
      onSuccess: ({ success, message }) => {
        if (success) {
          setUserDetails({
            ...userDetails,
            totalVideoUploaded:
              userDetails.totalVideoUploaded > 0
                ? userDetails.totalVideoUploaded + 1
                : 1,
            totalContentUploaded:
              userDetails.totalContentUploaded > 0
                ? userDetails.totalContentUploaded + 1
                : 1,
          });
          setVideoPublishStatus(true);
          if (conversionStart) {
            onHide();
            setTimeout(() => {
              navigate(Pathname.processingInBackGround);
              window.location.replace(Pathname.yourVideos + '?showModal=1'); // eslint-disable-line prefer-template
            }, 500);
          } else {
            setTimeout(() => {
              onHide();
              // eslint-disable-line prefer-template
              window.location.replace(Pathname.yourVideos + '?showModal=1'); // eslint-disable-line prefer-template
            }, 3000);
          }
        } else {
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong',
        });
      },
    });
  // Call moveToNextStep() when the API call starts or is in progress
  useEffect(() => {
    if (uploadingVideo) {
      moveToNextStep();
    }
  }, [uploadingVideo]);
  const { isValidating: updatingAlbum, mutate: addEditAlbum } = useSWR(
    [endpoints.addEditAlbum, albumTitle, albumDescription, source?.token],
    {
      fetcher: (url, title, description, uniqueCancelToken) => dataFetcher(
          url,
          { title: albumTitle, description: albumDescription },
          uniqueCancelToken
        ),
      onSuccess: ({ success, album_id, message }) => {
        setLoader(false);
        if (success) {
          setAlbumId(album_id);
          setChooseAlbumStep(4);
        } else {
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: 'Oops! Something went wrong!!',
        });
      },
    }
  );
  const uploadImageByBatch = async (data) => {
    const response = await axios.post(endpoints.addPhotoContent, data);
    return response;
  };
  const uploadByPartPhotos = async () => {
    const totalPhotos = photoFile.length;
    let batchSize = 5;
    if (totalPhotos > 100 && totalPhotos < 500) {
      batchSize = Math.ceil(totalPhotos / 20);
    } else if (totalPhotos > 499 && totalPhotos < 2000) {
      batchSize = Math.ceil(totalPhotos / 50);
    } else if (totalPhotos > 1999) {
      batchSize = Math.ceil(totalPhotos / 100);
    }
    let totalSize = 0;
    for (let i = 0; i < totalPhotos; i += 1) {
      const photo = photoFile[i];
      totalSize += photo.file.size;
    }
    let currentIndex = 0;
    let successfulUploadCount = 0;
    let successfulUploadSizes = 0;
    updateUploadPercentages(albumId, 'Loading');
    updateUploadSizes(albumId, 'Loading');
    async function uploadNextBatch() {
      if (currentIndex >= totalPhotos) {
        return;
      }
      const batch = photoFile.slice(currentIndex, currentIndex + batchSize);
      const batchFormData = new FormData();
      batchFormData.append('album_id', albumId ?? chooseExistingAlbum);
      let size = 0;
      batch.forEach((photo) => {
        const originalFile = photo.file;
        const safeName = originalFile.name.replace(/#/g, '_');

        const sanitizedFile = new File([originalFile], safeName, {
          type: originalFile.type,
          lastModified: originalFile.lastModified,
        });

        batchFormData.append('photo_file[]', sanitizedFile);
        size += sanitizedFile.size;
      });

      try {
        await uploadImageByBatch(batchFormData);
        currentIndex += batchSize;
        successfulUploadCount += batch.length;
        successfulUploadSizes += size;
        updateUploadPercentages(
          albumId,
          `${successfulUploadCount}/${totalPhotos}`
        );
        updateUploadSizes(
          albumId,
          `${
            (successfulUploadSizes / (1024 * 1024)).toFixed(1) > 1000
              ? `${(successfulUploadSizes / (1024 * 1024)).toFixed(1)} GB`
              : `${(successfulUploadSizes / (1024 * 1024)).toFixed(1)} MB`
          }/${
            (totalSize / (1024 * 1024)).toFixed(2) > 1000
              ? `${(totalSize / (1024 * 1024)).toFixed(2)} GB`
              : `${(totalSize / (1024 * 1024)).toFixed(2)} MB`
          }`
        );
        await uploadNextBatch();
      } catch (error) {
        console.log('Error uploading batch:', error);
      }
    }
    await uploadNextBatch();
    updateUploadPercentages(albumId, null);
    const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
    const totalSizeGB = (totalSizeMB / 1024).toFixed(2);
    const sizeString = totalSizeGB > 1 ? `${totalSizeGB} GB` : `${totalSizeMB} MB`;
    updateUploadSizes(albumId, sizeString);
  };

  const { isValidating: addingPhotos, mutate: addPhotoContent } = useSWR(
    [endpoints.addPhotoContent, albumUploadData],
    {
      fetcher: (url, formData) => dataFetcher(url, formData),
      onSuccess: ({ success, total_count, has_subsription, message }) => {
        if (success) {
          settextOfUpload('Done');
          uploadByPartPhotos();
          if (has_subsription) {
            if (total_count) {
              setUserDetails({
                ...userDetails,
                totalContentUploaded:
                  userDetails.totalContentUploaded > 0
                    ? userDetails.totalContentUploaded + 1
                    : 1,
              });
            }
            window.sessionStorage.setItem('tabTitle', 1);
            setTabTitle(1);
            setTimeout(() => {
              handleClose();
              setaddMorePhoto(false);
              setPageLoad(true);
              localStorage.setItem('isFromUpload', true);
              if (
                userDetails.totalContentUploaded === 0
                && !userDetails?.isSubscription
              ) {
                window.location.replace(`${Pathname.yourVideos}?showModal=1`);
              } else {
                navigate(Pathname.yourVideos);
              }
            }, 4000);
          } else {
            const albID = isAnExistingAlbum ? chooseExistingAlbum : albumId;
            setTimeout(() => {
              handleClose();
              // navigate(Pathname.purchasePlan('album', albID));
            }, 4000);
          }
        } else {
          setaddMorePhoto(false);
          setAppSnackbar({ isVisible: true, type: 'error', message });
        }
        setTimeout(() => {
          setVideoUploadPercentage(videoUploadPercentage + 1);
        }, 0);
        setTimeout(() => {
          setVideoUploadPercentage(100);
        }, 200);
        setTimeout(() => {
          setVideoUploadingCompleted(true);
        }, 1000);
        setTimeout(() => {
          setrunLoader(false);
        }, 5500);
        autoSignIn();
        setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => String(id) !== String(albumId)));
      },
      onError: (error) => {
        const responseData = error?.response?.data;
        setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => String(id) !== String(albumId)));
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message: responseData?.message || 'Oops! Something went wrong!!',
        });
        if (responseData?.message === 'Storage Space Exceeded') {
          handleClose();
          setTimeout(() => {
            navigate(Pathname.upgradePlan);
          }, 500);
        }
        setTimeout(() => {
          setVideoUploadPercentage(videoUploadPercentage + 1);
        }, 0);
        setTimeout(() => {
          setVideoUploadPercentage(100);
        }, 100);
        setTimeout(() => {
          setVideoUploadingCompleted(true);
        }, 1000);
        setTimeout(() => {
          setrunLoader(false);
        }, 5500);
      },
    }
  );

  const { isValidating: gettingAlbumList, mutate: getAlbumsList } = useSWR(
    endpoints.getAlbumList,
    {
      onSuccess: ({ success, data }) => {
        if (success) {
          setAlbumList(data);
        } else {
          setAppSnackbar({
            isVisible: true,
            type: 'error',
            message:
              'Oops! Something went wrong while fetching your photo albums',
          });
        }
      },
      onError: () => {
        setAppSnackbar({
          isVisible: true,
          type: 'error',
          message:
            'Oops! Something went wrong while fetching your photo albums',
        });
      },
    }
  );
  const uploadPhotoToExistingAlbum = () => {
    const formData = new FormData();
    formData.append('album_id', chooseExistingAlbum);
    photoFile.forEach((photo) => {
      const originalFile = photo.file;
      const safeName = originalFile.name.replace(/#/g, '_');

      const sanitizedFile = new File([originalFile], safeName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
      });
      formData.append('photo_file[]', sanitizedFile);
    });

    setAlbumUploadData(formData);
  };

  useEffect(() => {
    getAlbumsList();
  }, []);
  const getBase64FromFile = (inputFile) => {
    const fileReader = new FileReader();

    return new Promise((resolve) => {
      fileReader.onerror = () => {
        fileReader.abort();
        resolve('');
      };

      fileReader.onload = () => {
        resolve(fileReader.result.replace(/^data:.+;base64,/, ''));
      };
      fileReader.readAsDataURL(inputFile);
    });
  };

  const getBase64VideoThumbnails = async () => {
    let base64VideoThumbnails = '';

    return new Promise((resolve) => {
      videoThumbnails?.forEach(async (videoThumbnail, idx) => {
        const base64Thumbnail = await getBase64FromFile(videoThumbnail);

        base64VideoThumbnails = `${base64VideoThumbnails}${base64Thumbnail}`;

        if (idx + 1 < videoThumbnails?.length) {
          base64VideoThumbnails = `${base64VideoThumbnails}, }`;
        }

        if (idx + 1 === videoThumbnails?.length) {
          resolve(base64VideoThumbnails);
        }
      });
    });
  };

  // Creating payload for first addvideoCotnet api
  const uplodingVideo = () => {
    let uniqueKeyid;
    // Check if s3Data is FormData or regular object
    if (s3Data instanceof FormData && s3Data.get('draft_id')) {
      uniqueKeyid = s3Data.get('draft_id');
    } else if (s3Data.draft_id) {
      uniqueKeyid = s3Data.draft_id;
    } else {
      uniqueKeyid = uuid();
      const initialData = new FormData();
      initialData.append('draft_id', uniqueKeyid);
      setS3Data(initialData);
    }
    localStorage.setItem('draftId', uniqueKeyid);
    // Store pre-upload count for ecosystem redirect check
    localStorage.setItem('preUploadCount', userDetails?.totalContentUploaded || 0);
    setUniqueid(uniqueKeyid);
    localStorage.setItem('draftId', uniqueKeyid);
    const formData = new FormData();
    formData.append('status', 0);
    formData.append('video_file', videoFile);
    formData.append('draft_id', uniqueKeyid);
    setVideoUploadData(formData);
    // if (currentStep === 0) {
    //   setrunLoader(true);
    // }
  };

  function changeSize(size) {
    const newSize = size / 1024 / 1024;
    return newSize.toFixed(2);
  }

  const videoRef = useRef(null);

  const tryToPurchase = () => {
    handleClose();
    setTrailPopUpModalVisible(true);
  };

  function generateThumbnails(videoFile) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = 100;
    canvas.height = 100;
    context.fillStyle = 'red';
    context.fillRect(0, 0, canvas.width, canvas.height);
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve([blob]);
      });
    });
  }
  const updateItem = (percentage, draft_id, filename, uploadPercentages, updateUploadPercentages) => {
    const percent = parseInt((percentage / totalNum[draft_id]) * 100, 10);
    const trimmedFilename = filename.length > 26 ? `${filename.substring(0, 26)}...` : filename;
    const newPercentages = { ...uploadPercentages, [draft_id]: percent };
    tempPercentages = newPercentages;
    updateUploadPercentages(draft_id, percent);
    toast.update(draft_id, { render: `${trimmedFilename} ${percent}%`, autoClose: false });
  };
  async function uploadPart(bucket, key, partNumber, partBody, uploadId, setVideoUploadedParts, filename, draft_id, uploadPercentages, updateUploadPercentages, partSize, startTime, fileSize) {
    const params = {
      Bucket: bucket,
      Key: key,
      PartNumber: partNumber,
      UploadId: uploadId,
      Body: partBody,
    };
    return s3.uploadPart(params)
      .promise()
      .then((data) => {
        const currentTime = new Date().getTime();
        const elapsedSize = (partNumber * partSize) / 1024 / 1024;
        const elapsedTime = (currentTime - startTime) / 1000;
        const remainingSize = (fileSize / 1024 / 1024) - elapsedSize;
        iteratorNum[draft_id] += 1;
        updateItem(iteratorNum[draft_id], draft_id, filename, uploadPercentages, updateUploadPercentages);
        return data;
      })
      .catch((error) => {
        console.error(`AWS Multipart Upload : Error uploading part ${partNumber}:`, error);
        throw error;
      });
  }

  async function completeMultipartUpload(bucket, key, parts, uploadId) {
    const params = {
      Bucket: bucket,
      Key: key,
      MultipartUpload: {
        Parts: parts,
      },
      UploadId: uploadId,
    };
    return s3.completeMultipartUpload(params).promise();
  }

  const notify = (filename, draft_id, uploadPercentages, updateUploadPercentages) => {
    setTimeout(() => {
      const newPercentages = { ...uploadPercentages, [draft_id]: 'Starting Upload' };
      tempPercentages = newPercentages;
      updateUploadPercentages(draft_id, 'Starting Upload');
      const trimmedFilename = filename.length > 26 ? `${filename.substring(0, 26)}...` : filename;
      toast(trimmedFilename, {
        autoClose: false,
        toastId: draft_id,
        position: toast.POSITION.BOTTOM_RIGHT,
        closeButton: false,
        toastClassName: 'custom-toast'
      });
    }, 0);
  };

  const handleCompleteS3Upload = (data, draft_id) => {
    setfetchDraftID(draft_id);
    if (formDataJsonString[draft_id]) {
      let formDataArray = JSON.parse(formDataJsonString[draft_id]);
      formDataArray = formDataArray.map(([key, value]) => {
        if (key === 's3_url') {
          return [key, data?.Location];
        }
        return [key, value];
      });
      try {
        const videoPlayer = document.createElement('video');
        videoPlayer.src = data?.Location;
        videoPlayer.addEventListener('loadedmetadata', () => {
          const { videoHeight } = videoPlayer;
          const { videoWidth } = videoPlayer;
          formDataArray.push(['videoHeight', videoHeight]);
          formDataArray.push(['videoWidth', videoWidth]);
        });
        videoPlayer.load();
      } catch (error) {
        //
      }
      formDataArray.push(['s3_status', 'Completed']);
      const retrievedFormData = new FormData();
      formDataArray.forEach(([key, value]) => {
        retrievedFormData.append(key, value);
      });
      setFormData(retrievedFormData);
      setS3UploadComplete((prevStatus) => ({
        ...prevStatus,
        [draft_id]: true,
      }));
    }
  };
  async function uploadPartSequentially(file, bucket, key, uploadId, partNumber, start, partSize, parts, draft_id, startTime) {
    const end = Math.min(start + partSize, file.size);
    const data = {};
    const dataCallback = (snapshot) => {
      if (snapshot.exists()) {
        const dataObj = snapshot.val();
        data[draft_id] = dataObj[draft_id];
      }
    };
    onValue(databaseRef, dataCallback);
    const unsubscribe = () => {
      off(databaseRef, 'value', dataCallback);
    };
    if (data[draft_id]?.status !== 'DELETED') {
      await uploadPart(getBucketName(userDetails?.isSubscription?.user_id), key, partNumber, file.slice(start, end), uploadId, () => {}, file.name, draft_id, uploadPercentages, updateUploadPercentages, partSize, startTime, file.size)
      .then((item) => {
        parts.push({ PartNumber: partNumber, ETag: item.ETag });
      });
    } else {
      unsubscribe();
    }
    unsubscribe();
    if (end < file.size) {
      await uploadPartSequentially(file, bucket, key, uploadId, partNumber + 1, end, partSize, parts, draft_id, startTime);
    }
  }

  async function uploadLargeFile(bucket, key, file, draft_id) {
    setUploadContainer((prevUploadContainer) => [...prevUploadContainer, draft_id]);
    setUploadContainer2((prevUploadContainer) => [...prevUploadContainer, draft_id]);

    try {
      notify(file.name, draft_id, uploadPercentages, updateUploadPercentages);
      const { UploadId } = await initMultipartUpload(bucket, key);
      const minimumPartSize = 5 * 1024 * 1024;
      let partSize = file.size / 100;
      if (partSize < minimumPartSize) {
        partSize = minimumPartSize;
      }
      const fileSize = file.size;
      const partCount = Math.ceil(fileSize / partSize);
      const startTime = new Date().getTime();
      const parts = [];
      iteratorNum[draft_id] = 0;
      totalNum[draft_id] = partCount;
      await uploadPartSequentially(file, bucket, key, UploadId, 1, 0, partSize, parts, draft_id, startTime);
      const data = {};
      const dataCallback = (snapshot) => {
        if (snapshot.exists()) {
          const dataObj = snapshot.val();
          data[draft_id] = dataObj[draft_id];
        }
      };
      onValue(databaseRef, dataCallback);
      const unsubscribe = () => {
        off(databaseRef, 'value', dataCallback);
      };
      if (data[draft_id]?.status !== 'DELETED') {
        const uploadedData = await completeMultipartUpload(bucket, key, parts, UploadId);
        handleCompleteS3Upload(uploadedData, draft_id);
        closeToast(draft_id, 'Uploading completed', 'success');
        const newPercentages = { ...uploadPercentages, [draft_id]: 'Please wait' };
        tempPercentages = newPercentages;
        updateUploadPercentages(draft_id, 'Please wait');
        iteratorNum[file.name] = 0;
        totalNum[draft_id] = 0;
        setIamUploading(true);

        // Set up draft category state for automatic processing after upload completes
        if (imageFiles?.length > 0) {
          const video = document.createElement('video');
          video.src = URL.createObjectURL(file);
          video.onloadedmetadata = () => {
            const orientation = video.videoHeight < video.videoWidth ? 1 : 2;
            setDraftCategoryState((prevDraftCategoryState) => ({
              ...prevDraftCategoryState,
              [localStorage.getItem('opened_draft_id')]: {
                title: file.name.split('.').slice(0, -1).join('.'),
                category_id: undefined,
                subcategory_id: undefined,
                thumbnail_list: [],
                thumbnailx: null,
                customThumbnails: [],
                visibility: '2',
                description: '',
                videoHeight: video.videoHeight || 0,
                videoWidth: video.videoWidth || 0,
                videoOreintation: orientation,
                playlist_ids: undefined,
                video_duration: video.duration || 0,
                group_ids: undefined,
                videoGroup: undefined,
              },
            }));

            // Trigger the addVideo process after upload and metadata loading
            dispatch(setAddVideo({ draftId: draft_id, value: true }));

            URL.revokeObjectURL(video.src);
          };
          video.load();
        }
      } else {
        updateUploadPercentages(draft_id, 'Cancelled');
        closeToast(draft_id, 'Upload has been canceled by user', 'error');
        unsubscribe();
      }
      unsubscribe();
    } catch (error) {
      updateUploadPercentages(draft_id, 'Cancelled');
      closeToast(draft_id, 'Upload has been canceled by user', 'error');
      const newPercentages = { ...uploadPercentages, [draft_id]: 'Cancelled' };
      tempPercentages = newPercentages;
      updateUploadPercentages(draft_id, 'Cancelled');
      const allPropertiesAreNumericOrString = Object.values(uploadPercentages).some((value) => typeof value === 'number' || value === 'Starting Upload' || value === 'Initializing');
      if (allPropertiesAreNumericOrString) {
        setIamUploading(false);
      } else setIamUploading(true);
    }
  }

  const spinerSmall = 'spinex';
  const CustomCloseloader = () => (
    <button className={styles.closeMeBro}>
      <Spinner spinex={spinerSmall} />
    </button>
  );
  const updateDummy = (dummy, status = 0) => {
    if (status === 1) {
      dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
    } else {
      dispatch(removeDummy(dummy));
    }
  };
  const handleEncouter = (draft_id) => {
    toast.update(draft_id, {
      closeButton: <CustomCloseloader />,
    });
    changeFieldFromFirebase(
      draft_id?.draft_id ? draft_id?.draft_id : draft_id,
      'DELETED'
    );
    updateDummy(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 0);
    setIamUploading(false);
    updateUploadPercentages(
      draft_id?.draft_id ? draft_id?.draft_id : draft_id,
      'Cancelled'
    );
    closeToast(
      draft_id?.draft_id ? draft_id?.draft_id : draft_id,
      'Upload has been canceled by user',
      'error'
    );
  };
  const backToOld = ({ draft_id }) => {
    toast.update(draft_id, {
      closeButton: <CustomCloseButton draft_id={draft_id} />,
    });
  };
  const CustomCloseDiv = (draft_id) => (
    <div className={styles.customDiv}>
      Are you sure you want to cancel ?
      <div className={styles.fleo}>
        <button
          className={styles.cancelPlz}
          onClick={() => backToOld(draft_id)}
        >
          Exit
        </button>
        <button
          className={styles.noCancel}
          onClick={() => handleEncouter(draft_id)}
        >
          Continue to cancel
        </button>
      </div>
    </div>
  );
  const handleClick = (draft_id) => {
    toast.update(draft_id, {
      closeButton: <CustomCloseDiv draft_id={draft_id} />,
    });
  };

  const CustomCloseButton = ({ draft_id }) => (
    <button className={styles.closeMeBro} onClick={() => handleClick(draft_id)}>
      <CloseIcon />
    </button>
  );
  const [buttonDisabled, setButtonDisabled] = useState(false);
  useEffect(() => {
if (
  !videoTitle
  || ((videoThumbnails?.length ?? 0) === 0 && (customVideoThumbnails?.length ?? 0) === 0)
) {
  setButtonDisabled(true);
} else {
  setButtonDisabled(false);
}
  }, [videoTitle, videoThumbnails?.length, customVideoThumbnails?.length]);
  // Create payload for save to draft api
  async function handleUploadFiles(e, passedFile = null) {
    const allowedFormats = ['.mp4', '.mov', '.mpg', '.m4v', '.m2ts'];
    const MAX_SIZE_BYTES = MAX_SIZE_GB * 1024 * 1024 * 1024;
    const files = passedFile ? [passedFile] : Array.from(e.target.files);
    const userId = userDetails?.isSubscription?.user_id;

    if (files.length > MAX_VIDEOS && subscriptionDetails?.subscription?.is_trial === '1') {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: (
          <>
          You can select a maximum of
          {' '}
          {MAX_VIDEOS}
          {' '}
          videos.
          {' '}
          <span
            role="button"
            tabIndex={0}
            style={{ color: '#0075FF', cursor: 'pointer' }}
            onClick={() => tryToPurchase()}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                tryToPurchase();
              }
            }}
          >
            Upgrade
          </span>
          </>),
        duration: 5000,
      });
      return;
    }

    if (files.length > MAX_VIDEOS) {
      setAppSnackbar({ isVisible: true, type: 'error', message: `You can select a maximum of ${MAX_VIDEOS} videos.` });
      return;
    }

    const totalSize = files.reduce((acc, file) => acc + file.size, 0);
    // if (totalSize > MAX_SIZE_BYTES) {
    //   setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    //   return;
    // }

    if (passedFile || (e.target.files && e.target.files.length === 1)) {
      const file = passedFile || e.target.files[0];
      if (!file) {
        return;
      }
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!allowedFormats.includes(`.${fileExtension}`)) {
        setAppSnackbar({ isVisible: true, type: 'error', message: `Invalid file format. Allowed formats are: ${allowedFormats.join(', ')}` });
        return;
      }
      const blobFile = [];
      const thumbnails = await generateThumbnails(file);
      const videoBlob = new Blob([file], { type: file.type });
      blobFile.push(videoBlob);
      thumbnails.forEach((thumbnail) => {
        const thumbnailBlob = new Blob([thumbnail], { type: thumbnail.type });
        blobFile.push(thumbnailBlob);
      });
      const video = videoRef.current;
      setSingleUpload(file);
      const number = Math.floor(Math.random() * 10000) + 1;
      const fileName = (`${Date.now()}-${userId}-video-${number}.${fileExtension}`);
      const formData = new FormData();
      const initialData = new FormData();
      const s3Url = generateS3Url();
      if (file && video) {
        video.src = URL.createObjectURL(file);
        video.onloadedmetadata = () => {
          formData.append('videoDuration', video.duration);
        };
      }
      const draftId = localStorage.getItem('draftId');
      localStorage.setItem('opened_draft_id', draftId);
      // setfetchDraftID(draftId);
      initialData.append('draft_id', draftId);
      initialData.append('s3_url', `${s3Url}${fileName}`);
      setS3Data(initialData);
      formData.append('draft_id', draftId);
      formData.append('file_name', fileName);
      formData.append('video_size', changeSize(file.size));
      const thumbanilsBlob = [];
      blobFile.forEach((file, index) => {
        thumbanilsBlob.push(file);
      });
      formData.append('s3_image_bucket_url', s3Url);
      formData.append('s3_url', `${s3Url}${fileName}`);
      formData.append('bucket_folder_path', `${getBucketNamePath(userId)}/${fileName}`);
      formDataJsonString[draftId] = JSON.stringify([...formData.entries()]);

      // Start the actual S3 upload
      uploadLargeFile(getBucketName(userId), fileName, file, draftId);
    } else if (e?.target?.files?.length > 1) {
      setSelectedFiles(e.target.files);
      handleClose();
    }
  }
  const handleSaveToDraft = () => {
    navigateToInviteFirstTime();
    toast.update(uniqueid, {
      closeButton: <CustomCloseButton draft_id={uniqueid} />,
    });
    const modifiedArray = videoThumbnails.map((elem) => elem.replace('data:image/png;base64,', ''));
    const formData = new FormData();
    if (uploadedData?.category_id && videoVisibility && defaultVideoThumbnail) {
      setUploadingInProgress({ ...uploadingInProgress, video: true });
    } else {
      setUploadingInProgress({ ...uploadingInProgress, draft: true });
    }
    // Append parameters to the FormData object
    // Required
    formData.append('draft_id', uniqueid);
    formData.append('draft_content_id', draftId);
    // Optional
    if (videoTitle === '' || videoTitle === undefined) {
      formData.append('title', fileName);
    } else {
      formData.append('title', videoTitle);
    }
    const video = document.getElementById('video-player');
    video.addEventListener('loadedmetadata', () => {
      formData.append('videoOreintationx', video.videoWidth);
    });
    const orientation = video.videoHeight < video.videoWidth ? 1 : 2;
    formData.append('videoOreintation', orientation);
    formData.append('videoHeight', video.videoHeight);
    formData.append('videoWidth', video.videoWidth);
    videoDescription && formData.append('description', videoDescription);
    videoVisibility && formData.append('visibility', videoVisibility);
    uploadedData?.playlist_id
      && formData.append('playlist_id', uploadedData?.playlist_id);
    uploadedData?.category_id
      && formData.append('category_id', uploadedData?.category_id);
    uploadedData?.subcategory_id
      && formData.append('subcategory_id', uploadedData?.subcategory_id);
    videoGroup && formData.append('group_id', videoGroup); // Gruop added to payload.
    videoThumbnails?.length
      && formData.append('thumbnail_list', modifiedArray.join('####'));
    videoThumbnails?.length
      && formData.append('thumbnail_selected', modifiedArray[0]);
    // videoDetails && videoDetails?.size && formData.append('video_size', fileSize(videoDetails?.size));
    videoDetails
      && videoDetails?.size
      && formData.append('video_size', changeSize(videoDetails?.size));
    videoDetails
      && videoDetails?.duration
      && formData.append('video_duration', videoDetails?.duration);
    setDraftCategoryState((prevDraftCategoryState) => ({
      ...prevDraftCategoryState,
      [localStorage.getItem('opened_draft_id')]: {
        title:
          videoTitle === '' || videoTitle === undefined ? fileName : videoTitle,
        category_id: uploadedData?.category_id,
        subcategory_id: uploadedData?.subcategory_id,
        thumbnail_list:
          defaultVideoThumbnail !== noPhotoAvailable
          && defaultVideoThumbnail
          && defaultVideoThumbnail !== generatingThumbnail
            ? blobFile
            : [],
        thumbnailx: defaultVideoThumbnail,
        customThumbnails: customVideoThumbnails,
        visibility: videoVisibility,
        description: videoDescription,
        videoHeight: video.videoHeight,
        videoWidth: video.videoWidth,
        videoOreintation: orientation,
        playlist_ids: uploadedData?.playlist_id,
        video_duration: videoDetails?.duration,
        group_ids: videoGroup,
        videoGroup,
      },
    }));
    // setFormData(blobFile);
    blobFile.forEach((file, index) => {
      formData.append('thumbnails[]', file, `thumbnail_${index + 1}.jpg`);
    });
    if (
      defaultVideoThumbnail !== noPhotoAvailable
      && defaultVideoThumbnail
      && defaultVideoThumbnail !== generatingThumbnail
    ) {
      thumbnailType === 'normal' && formData.append('thumbnail', blobFile[0]);
      thumbnailType === 'custom'
        && formData.append(
          'custom_thumbnails',
          defaultVideoThumbnail.split('base64,')[1]
        );
    }
    formData.append('status', 2);
    // setVideoUploadData(formData);
    let type_of;
    let contentStatus;
    if (
      uploadedData?.category_id
      && uploadedData?.category_id !== 'delete'
      && defaultVideoThumbnail !== noPhotoAvailable
      && defaultVideoThumbnail
      && defaultVideoThumbnail !== generatingThumbnail
      && videoVisibility
    ) {
      type_of = 0;
      contentStatus = 'Video';
    } else {
      type_of = 2;
      contentStatus = 'Draft';
    }
    const currentDate = new Date();
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const formattedDate = `${String(month).padStart(2, '0')}/${String(
      date
    ).padStart(2, '0')}/${year}`;
    const thum = defaultVideoThumbnail !== noPhotoAvailable
      && defaultVideoThumbnail
      && defaultVideoThumbnail !== generatingThumbnail
      && defaultVideoThumbnail !== undefined
        ? `data:image/png;base64, ${defaultVideoThumbnail.split('base64,')[1]}`
        : null;
    const titleName = videoTitle === '' || videoTitle === undefined ? fileName : videoTitle;
    const dummy = {
      draft_id: localStorage.getItem('opened_draft_id'),
      title: titleName,
      thumbnail: thum,
      category: uploadedData?.category_name,
      video_description: videoDescription,
      created: formattedDate,
      video_size: changeSize(videoDetails?.size),
      type: 0,
      group_id: uploadedData?.group_id,
      content_status: contentStatus,
      uploadIsTrying: 1,
    };
    if (!uploadPercentages[uniqueid]) {
      updateUploadPercentages(uniqueid, 'Initializing');
    }
    updateDummy(dummy, 1);
    setDraftApiStatus('loading');
    setisAddDraftDone(true);

    // if (isS3UploadComplete[dummy?.draft_id] === true) {
    //   addVideo(formData).then((response) => {
    //     updateDummy(dummy?.draft_id, 0);
    //     toast.update(uniqueid, { closeButton: <CustomCloseButton draft_id={uniqueid} /> });
    //     setDraftApiStatus('success');
    //     setUploadingInProgress({});
    //     setisAddDraftDone(false);
    //   })
    //     .catch((error) => {
    //       setDraftApiStatus('error');
    //       // Handle errors
    //       console.log('Error adding video draft:', error);
    //     });
    // } else {

    // }
    localStorage.removeItem('draftId');
    handleClose();
    if (
      uploadedData?.category_id
      && videoVisibility
      && defaultVideoThumbnail !== noPhotoAvailable
      && defaultVideoThumbnail
      && defaultVideoThumbnail !== generatingThumbnail
    ) {
      handleClose(SAVE_TYPE.PUBLISH);
    } else {
      handleClose(SAVE_TYPE.DRAFT);
    }
    // setTimeout(() => {
    //   setAppSnackbar({ isVisible: true, type: 'success', message: 'Video details updating ....' });
    // }, 2000);
  };

  const uploadVideo = async () => {
    const formData = new FormData();

    if (!videoIsUploaded) {
      setUploadedData({
        ...uploadedData,
        description: videoDescription,
        title: videoTitle,
        video_file: videoFile,
        thumbnails: videoThumbnails,
      });
      if (videoDescription) {
        formData.append('description', videoDescription);
      }
      if (videoTitle) {
        formData.append('title', videoTitle);
      }
      // if (videoThumbnails) { formData.append('thumbnails', await getBase64VideoThumbnails()); }
      if (videoThumbnails) {
        thumbnailType === 'normal'
          ? formData.append('thumbnails', defaultVideoThumbnail)
          : formData.append(
              'custom_thumbnails',
              defaultVideoThumbnail.split('base64,')[1]
            );
      }
      formData.append('status', 0);
      formData.append('video_id', videoID);
      // formData.append('video_file', videoFile);
    } else {
      setUploadedData({
        ...uploadedData,
        ...(videoThumbnails !== uploadedData.thumbnails && {
          thumbnails: videoThumbnails,
        }),
        ...(videoDescription !== uploadedData.description && {
          description: videoDescription,
        }),
        ...(videoTitle !== uploadedData.title && { title: videoTitle }),
      });
      formData.append('video_id', videoID);
      // formData.append('video_id', videoID);

      if (videoThumbnails !== uploadedData.thumbnails) {
        thumbnailType === 'normal'
          ? formData.append('thumbnails', defaultVideoThumbnail)
          : formData.append(
              'custom_thumbnails',
              defaultVideoThumbnail.split('base64,')[1]
            );
      }
      if (videoDescription !== uploadedData.description) {
        formData.append('description', videoDescription);
      }
      if (videoTitle !== uploadedData.title) {
        formData.append('title', videoTitle);
      }
    }
    setVideoUploadData(formData);
  };

  const updateVisibility = () => {
    const formData = new FormData();
    setUploadedData({
      ...uploadedData,
      ...(videoVisibility !== uploadedData.visibility && {
        visibility: videoVisibility,
      }),
      ...(videoVisibility === '3' && { group_id: videoGroup }),
    });
    formData.append('video_id', videoID);
    formData.append('visibility', videoVisibility);
    formData.append('status', 1);
    if (videoVisibility === '3') {
      formData.append('group_id', videoGroup);
    }
    setVideoVisibilityData(formData);
  };
  const convertFormDataToJson = (formData) => {
    const formDataJson = {};
    formData.forEach((value, key) => {
      formDataJson[key] = value;
    });
    const formDataJsonString = JSON.stringify(formDataJson);
    return formDataJsonString; // You can do whatever you want with the JSON data
  };
  const handleAddS3Video = () => {
    setIsSelectedFile(true);
    // addS3VideoDraftContent(s3Data).then((response) => {
    //   setButtonDisabled(false);
    //   if (!s3Data?.has('draft_content_id') && response?.data?.draft_content_id !== undefined) {
    //     setdraftId(response?.data?.draft_content_id);
    //     setUniqueid(s3Data.get('draft_id'));
    //     // updatedFormData.append('draft_content_id', response?.data?.draft_content_id);
    //     // setS3Data(updatedFormData);
    //   }
    // });
  };

  useEffect(() => {
    if (videoUploadData && currentStep < 2) {
      moveToNextStep();
      handleAddS3Video();
    }
  }, [videoUploadData]);

  // useEffect(() => {
  //   if (s3Data?.s3_url) {
  //     uploadS3Video();
  //   }
  // }, [s3Data]);

  const addOrEditAlbum = () => {
    setLoader(true);
    addEditAlbum();
  };

  const convertBase64 = (file) => new Promise((resolve, rej) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    settextOfUpload('');
  }, []);
const fromWelcome = localStorage.getItem('pendingSingleUpload');
  useEffect(() => {
    if (videoFile && uploadType === 'video' && fromWelcome) {
      // Only trigger when videoFile comes from imageFiles (Welcome.jsx)
      handleUploadFiles(null, videoFile);
      setTimeout(() => {
     localStorage.removeItem('pendingSingleUpload');
      }, 100);
    }
  }, [videoFile, uploadType]);

  const publishAlbum = async () => {
    navigateToInviteFirstTime();
    setUploadContainer2((prevUploadContainer) => [
      ...prevUploadContainer,
      String(albumId),
    ]);
    settextOfUpload('Done');
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('album_id', albumId);
      formData.append('visibility', albumVisibility);
      if (albumVisibility === '3') {
        formData.append('group_id', videoGroup);
      }
      // photoFile.forEach((photo) => {
      //   formData.append('photo_file[]', photo.file);
      // });
      const base64 = await convertBase64(defaultAlbumThumbnail.file);
      // formData.append('icon', photoFile[0].file);
      formData.append('icon', base64);
      setAlbumUploadData(formData);
    } catch (error) {
      console.log('Error publishing album:', error);
    } finally {
      setLoading(false);
      // settextOfUpload('Done');
    }
  };

  useEffect(() => {
    if (albumUploadData) {
      if (subscriptionDetails?.has_activePlan) {
        setAlbumStatus('Album Published');
      } else {
        setAlbumStatus('Photo Uploaded');
      }
      setContentType('album');
      setAlbumPublishStatus(true);
      addPhotoContent();
    }
  }, [albumUploadData]);
  useEffect(() => {
    console.log('VideoFile useEffect triggered:', { videoUploadData: !!videoUploadData, videoFile: !!videoFile });
    if (!videoUploadData && videoFile) {
      console.log('Calling uplodingVideo() from videoFile useEffect');
      uplodingVideo();
    }
  }, [videoFile]);

  // Auto-upload effect for pre-selected files
  useEffect(() => {
    console.log('Auto-upload useEffect triggered:', { autoUpload, videoFile: !!videoFile, videoTitle, uploadingVideo, videoUploadData: !!videoUploadData });
    if (autoUpload && videoFile && videoTitle && !uploadingVideo && !videoUploadData) {
      console.log('Auto-upload conditions met, starting upload in 1 second...');
      // Trigger upload immediately when video file and title are ready
      const timer = setTimeout(() => {
        console.log('Auto-upload timer triggered, calling uplodingVideo()');
        uplodingVideo();
      }, 1000); // 1 second delay to allow video processing

      return () => clearTimeout(timer);
    }
  }, [autoUpload, videoFile, videoTitle, uploadingVideo, videoUploadData]);
  useEffect(() => {
    if (videoVisibilityData && currentStep === 3) {
      if (!subscriptionDetails?.has_activePlan) {
        handleClose();
        navigate(Pathname.purchasePlan('video', videoID));
        // setAppSnackbar({ isVisible: true, type: 'error', message: 'You must have purchase a plan to upload a video' });
      } else {
        updateVisibilityContent();
      }
    }
  }, [videoVisibilityData]);

  useEffect(
    () => () => {
      videoThumbnails.forEach((videoThumbnail) => {
        URL.revokeObjectURL(videoThumbnail);
      });
    },
    []
  );

  useEffect(() => {
    if (videoVisibility === videoVisibilityOptions[2].value) {
      document.getElementById('group-selector').scrollIntoView();
    }
  }, [videoVisibility]);
  function base64ToFile(base64String, fileName, index) {
    const byteString = atob(base64String);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i += 1) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
    const file = new File([blob], fileName, { type: 'image/jpeg' });
    return file;
  }
  const [screenshotsArray, setScreenshotsArray] = useState([]);
  const addScreenshot = (image, backend) => {
    if (
      backend === 'backend'
      && defaultVideoThumbnail === noPhotoAvailable
      && customVideoThumbnails?.length === 0
    ) {
      setDefaultVideoThumbnail(image);
    } else {
      setScreenshotsArray((prevScreenshots) => {
        const updatedScreenshots = [...prevScreenshots, image];
        // Set defaultVideoThumbnail only if it's currently set to noPhotoAvailable
        if (
          defaultVideoThumbnail === noPhotoAvailable
          && customVideoThumbnails?.length === 0
        ) {
          setDefaultVideoThumbnail(updatedScreenshots[0]);
        }
        return updatedScreenshots;
      });
    }
  };
  const isColoredImage = (base64Image) => new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = `data:image/png;base64,${base64Image}`;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, img.width, img.height).data;

        // Check each pixel: if R, G, B values differ, it's colored
        for (let i = 0; i < imageData.length; i += 4) {
          const [r, g, b] = [imageData[i], imageData[i + 1], imageData[i + 2]];
          if (!(r === g && g === b)) {
            resolve(true); // Colored pixel found
            return;
          }
        }

        resolve(false); // All pixels are grayscale
      };

      img.onerror = () => resolve(false);
    });

  const callBackendThumbnailAPI = async (file, index = 0) => {
    const videoFilePiece = new FormData();
    const chunkSize = 5 * 1024 * 1024;
    const start = index * chunkSize;
    const end = start + chunkSize;
    videoFilePiece.append('video_file', file.slice(start, end));
    videoFilePiece.append('draft_Id', localStorage.getItem('draftId'));
    try {
      const response = await fetch('https://conf.eq7.in/generate-thumbnail/', {
        method: 'POST',
        body: videoFilePiece,
      });

      if (!response.ok) {
        const text = await response.text();
        if (totalApiFailuresRef.current > 4) {
          setfailedToGenerate(true);
        }
        console.log(`Error: ${response.status} - ${text}`);
        throw new Error(`Server error ${response.status}: ${text}`);
      }
      const data = await response.json();

      if (data?.thumbnail) {
        const isColored = await isColoredImage(data?.thumbnail);

        if (!isColored) {
          console.warn(
            `🟪 Skipped thumbnail ${
              index + 1
            } — image appears to be fully grayscale`
          );
          return; // ❌ Skip this image, do not set state
        }

        const fileObj = base64ToFile(
          data?.thumbnail,
          `thumbnail_${index + 1}.jpg`
        );
        const base64 = `data:image/png;base64,${data?.thumbnail}`;

        blobFileRef.current = [...blobFileRef.current, fileObj];
        setBlobFile(blobFileRef.current);
        totalApiFailuresRef.current = 0;
        setIsThumbnailCreationFailed(false);
        setfailedToGenerate(false);
        setVideoThumbnails((prev) => [...prev, base64]);
        setDefaultVideoThumbnail(videoThumbnails[0] || base64);

        if (!customAdded.current && index === 0) {
          addScreenshot(base64, 'backend');
        }
      } else {
        setIsThumbnailCreationFailed(true);
        setDefaultVideoThumbnail(noPhotoAvailable);
      }
    } catch (error) {
      totalApiFailuresRef.current += 1;
      setIsThumbnailCreationFailed(true);
      if (failedToGenerate) {
        setDefaultVideoThumbnail(noPhotoAvailable);
      }
      console.log('Error during thumbnail generation', error);
    }
  };

  /* eslint-disable */
  const VideoFile = (e) => {
    const file = e;
    const titleFromFile = e.name.split(".").slice(0, -1).join(".");
    console.log('VideoFile called with:', file.name, 'Title:', titleFromFile);
    setFileName(titleFromFile);
    setVideoTitle(titleFromFile);
    const fileReader = new FileReader();
    setVideoDetails({
      name: file.name.split(".").slice(0, -1).join("."),
      size: file.size,
    });
    if (file.type.match("image")) {
      // Handle image file
      fileReader.onload = () => {
        setDefaultVideoThumbnail(fileReader.result);
      };
      fileReader.readAsDataURL(file);
    } else {
      // Handle video file for thumbnail generation
      const video = document.getElementById("video-player");
      const screenshots = [];
      let num = 0;
      let thumbnailsGenerated = 0;
      let hasAddedScreenshot = false;
      const snapImage = () => {
        try {
          // Check if video duration is valid before proceeding
          if (!video.duration || !isFinite(video.duration)) {
            return false;
          }
          video.currentTime += video.duration / 8; // Move to the next time point in the video
          num = parseInt(video.currentTime, 10);
          // Create canvas and draw the current video frame
          const canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const pixelData = imageData.data;
          // Check for transparency in the image
          const isTransparent = checkTransparency(pixelData);
          if (!isTransparent) {
            canvas.toBlob((blob) => {
              const thumbnailFile = new File(
                [blob],
                `thumbnail_${screenshots.length + 1}.jpg`,
                { type: "image/jpeg" }
              );
              setBlobFile((prevBlobFiles) => [...prevBlobFiles, thumbnailFile]);
            });
            const image = canvas.toDataURL();
            if (!screenshots.includes(image)) {
              screenshots.push(image);
              setVideoThumbnails(screenshots);
              setIsThumbnailCreationFailed(true);
              if (!hasAddedScreenshot) {
                addScreenshot(image);
                hasAddedScreenshot = true; // Set the flag to true after the first call
              }
            }
            thumbnailsGenerated++;
          } else {
            // callBackendThumbnailAPI(file);
          }
          // thumbnailsGenerated++;
          if (thumbnailsGenerated < 6) {
            video.currentTime += video.duration / 8; // Move to the next time point in the video
          } else {
            video.removeEventListener("timeupdate", timeupdate); // Stop after 6 thumbnails
            setIsThumbnailGenerationCompleteFully(true);
          }
        } catch (error) {
          console.log("Error taking snapshot", error);
          //  callBackendThumbnailAPI(file);
          // if (backendRetryCount < maxBackendRetries) {
          //   backendRetryCount++;
          //   console.warn(`Calling backend thumbnail API - attempt ${backendRetryCount}`);
          //   callBackendThumbnailAPI(file);
          // } else {
          //   console.warn("Backend thumbnail API failed 5 times. Not retrying further.");
          // }

          video.removeEventListener("timeupdate", timeupdate); // Stop on error
        }

        setVideoDetails({
          name: file.name.split(".").slice(0, -1).join("."),
          size: file.size,
          duration: video.duration,
        });

        setS3VideoDetails({
          file_name: file.name.split(".").slice(0, -1).join("."),
          size: file.size,
          videoDuration: video.duration,
        });
      };
      // Function to check if an image contains transparency
      const checkTransparency = (pixelData) => {
        const threshold = 0.1; // Set threshold for transparency (optional)
        let transparentPixels = 0;
        const totalPixels = pixelData.length / 4; // Each pixel is represented by 4 values (RGBA)
        for (let i = 3; i < pixelData.length; i += 4) {
          if (pixelData[i] === 0) {
            // Check if the alpha value is zero (fully transparent)
            transparentPixels++;
          }
        }
        const transparentRatio = transparentPixels / totalPixels;
        return transparentRatio > threshold; // Return true if a significant part of the image is transparent
      };
      const url = URL.createObjectURL(file);
      const timeupdate = () => {
        snapImage(); // Call the snapshot function on every timeupdate event
      };
      video.addEventListener("loadeddata", () => {
        snapImage(); // Start generating thumbnails when video is loaded
        setVideoDetails({
          name: file.name.split(".").slice(0, -1).join("."),
          size: file.size,
          duration: video.duration,
        });
      });
      setTimeout(async () => {
        if (thumbnailsGenerated === 0) {
          const maxRetriesPerAttempt = 5;
          const maxContinuousFailures = 5;

          let attemptIndex = 0;
          let continuousFailures = 0;

          while (blobFileRef.current.length < 5) {
            let retries = 0;
            let success = false;

            while (retries < maxRetriesPerAttempt && !success) {
              try {
                console.log(
                  `Attempting backend call for thumbnail ${
                    attemptIndex + 1
                  }, try ${retries + 1}`
                );
                await callBackendThumbnailAPI(file, attemptIndex);
                success = true;
                continuousFailures = 0; // ✅ Reset on success
              } catch (error) {
                retries++;
              }
            }

            if (success) {
              attemptIndex++;
            } else {
              continuousFailures++;
              console.log(
                `🚨 Failed to generate thumbnail ${
                  attemptIndex + 1
                } after ${maxRetriesPerAttempt} retries`
              );
            }
            console.log("totalApiFailuresRef", totalApiFailuresRef.current);

            if (totalApiFailuresRef.current >= maxContinuousFailures) {
              break;
            }
          }

          setIsThumbnailGenerationCompleteFully(true);
        } else {
          setIsThumbnailGenerationCompleteFully(true);
        }
      }, 4000);

      video.addEventListener("timeupdate", timeupdate); // Trigger image snapshot on timeupdate events
      video.preload = "metadata";
      video.src = url;
      video.muted = true;
      video.playsInline = true;
      if (video.play) {
        video.play();
      }
      setCurrentStep(0);
      setVideoFile(file);
    }
  };
const PhotoFile = (input) => {
  let selectedFiles = [];
  if (input?.target?.files) {
    selectedFiles = Array.from(input.target.files);
  }
  else if (input instanceof File) {
    selectedFiles = [input];
  }
  else if (Array.isArray(input)) {
    selectedFiles = input;
  }
  else if (imageFiles) {
    if (imageFiles instanceof File) {
      selectedFiles = [imageFiles];
    } else if (Array.isArray(imageFiles)) {
      selectedFiles = imageFiles;
    }
  }
  if (!selectedFiles.length) return;

    const currentPhotoCount = photoFile?.length || 0;
    const totalSelected = selectedFiles.length;
    const availableSlots = MAX_PHOTOS - currentPhotoCount;

    if (totalSelected > availableSlots) {
      setAppSnackbar({
        isVisible: true,
        message: `Please select no more than ${MAX_PHOTOS} photos per upload.`,
      });
      return;
    }

    // Only take files up to the limit
    const allowedFiles = Array.from(selectedFiles).slice(0, availableSlots);

    setMultiplePhoto(allowedFiles);
    const photoData = [];
    let albSize = 0;

    allowedFiles.forEach((file) => {
      photoData.push({ url: URL.createObjectURL(file), file });
      albSize += file.size;
    });
    setAlbumSize(albSize);

    const photoArray = [...photoFile, ...photoData];
    setPhotoFile(photoArray);
    setAlbumPhotoCount(photoArray.length);

    if (imageFiles?.length > 0) {
      setUpdateType('photo');
    }

    setChooseAlbumStep(2);
  };

  useEffect(() => {
    console.log('Initial imageFiles useEffect triggered:', { imageFilesLength: imageFiles?.length, firstFileType: imageFiles?.[0]?.type });
    if (imageFiles?.length > 0) {
      // Check if the file is a video file
      const firstFile = imageFiles[0];
      console.log('Processing file:', firstFile.name, 'Type:', firstFile.type);
      if (firstFile.type.startsWith('video/')) {
        // Handle video file
        console.log('Setting up auto-upload for video file');
        setUpdateType('video');
        setAutoUpload(true); // Flag to indicate this should auto-upload
        VideoFile(firstFile);
        // Set to step 1 to show video details and automatically start processing
        setTimeout(() => {
          console.log('Setting currentStep to 1');
          setCurrentStep(1);
        }, 100);
      } else {
        // Handle photo files
        PhotoFile();
      }
    }
    setHoldTheWeb(true);
  }, []);
  useEffect(() => {
    if (didIOpenModal === true) {
      handleClose();
    }
  }, [didIOpenModal]);

  const removePhoto = (index) => {
    const photoArray = [...photoFile]; // make a separate copy of the array
    photoArray.splice(index, 1);
    setPhotoFile(photoArray);
  };

  const getRandomImages = () => {
    let randomArray = [];
    if (images.length > 3) {
      randomArray = images.sort(() => 0.5 - Math.random()).slice(0, 3);
    } else {
      randomArray = [...images];
    }
    setAlbumThumbnails(randomArray);
    setDefaultAlbumThumbnail(randomArray[0]);
    setChooseAlbumStep(3);
  };
  const [allowJpg, setallowJpg] = useState(false);
  const VideoThumbnails = async (e) => {
    const files = e?.target?.files;
    if (files.length === 0) {
      return; // No files selected, do nothing
    }
    const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    if (!allowedTypes.includes(files[0].type)) {
      // setallowJpg(true);
      setAppSnackbar({
        isVisible: true,
        message: 'Only allow png, jpg, webp, jpeg',
      });
      return;
    }
    const tmpVideoThumbnails = [];
    const file = files[0];
    const base64 = await convertBase64(file);
    tmpVideoThumbnails.push(base64);
    setDefaultVideoThumbnail(base64);
    setThumbnailType('custom');
    setIsThumbnailCreationFailed(false);
    setCustomVideoThumbnails(tmpVideoThumbnails);
    customAdded.current = true;
  };

  const generateCustomThumbnail = async (e) => {
    const files = e?.target?.files;
    const tmpAlbumThumbnails = [];
    const file = files[0];
    const base64 = await convertBase64(file);
    tmpAlbumThumbnails.push(base64);
    setDefaultAlbumThumbnail({ file, url: URL.createObjectURL(file) });
    setCustomAlbumThumbnails([{ file, url: URL.createObjectURL(file) }]);
  };

  const selectGroup = (id) => {
    if (videoGroup.includes(id)) {
      setVideoGroup(videoGroup.filter((item) => item !== id));
    } else {
      setVideoGroup([...videoGroup, id]);
    }
  };
  const locationTracer = window.location.pathname;
  const closeButton = () => {
    isSelectedFile ? deleteAdded() : null;
    if (locationTracer === '/dashboard') {
      navigate(Pathname.upgradePlan);
    }
    handleClose();
  };
console.log('chooseAlbumStep', chooseAlbumStep, uploadType);
  return (
    <>
      <Fade in={isVisible} timeout={isVisible ? 300 : 250}>
        <div className={styles.body}>
          <video id="video-player" style={{ display: 'none' }} />
          <video ref={videoRef} style={{ display: 'none' }} controls />
          <input
            accept="image/*"
            // disabled={uploadingVideo}
            id="video-thumbnails"
            multiple
            onChange={(e) => {
              VideoThumbnails(e);
            }}
            style={{ display: 'none' }}
            type="file"
          />

          <DialogTitle className={styles.header}>
            <div
              style={{ border: [1, 2, 3].includes(currentStep) ? 'none' : '' }}
              className={styles.headerContent}
            >
              <BackIcon
                className={styles.backButton}
                onClick={uploadingVideo ? undefined : handleClose}
              />
              <Text.PageTitle
                className={`${styles.headerText} ${
                  videoDetails?.name && styles.headerTextSelectable
                }`}
              >
                {!videoIsPublished && !albumPublished
                  ? currentStep || uploadType === 'video'
                    ? videoTitle
                      || videoDetails.name
                      || 'Upload Video'
                      || uploadText?.videoHeader
                    : chooseAlbumStep
                    ? albumTitle || uploadText?.albumHeader || 'Upload Photo'
                    : uploadText?.header || 'Choose what to upload '
                  : videoIsPublished
                  ? uploadText?.videoPublished || 'Video Published'
                  : 'Album Published'}
              </Text.PageTitle>
              {draftApiStatus !== 'loading' && (
                <CloseIcon
                  className={styles.closeButton}
                  onClick={closeButton}
                />
              )}
            </div>
            {!videoIsPublished && (
              <>
                <ProgressTracker
                  currentStep={currentStep}
                  steps={[
                    uploadText?.detail || 'Details',
                    uploadText?.categories || 'Categories',
                    uploadText?.previousDetails || 'Previous Details',
                  ]}
                />
              </>
            )}
            {!videoIsPublished
              && !albumPublished
              && uploadType === 'photo'
              && (chooseAlbumStep === 3 || chooseAlbumStep === 4) && (
                <ProgressTracker
                  currentStep={chooseAlbumStep === 3 ? 1 : 2}
                  steps={[
                    uploadText?.detail || 'Details',
                    uploadText?.summary || 'Summary',
                  ]}
                />
              )}
            <InfoModal
              isVisible={allowJpg}
              title="Only allows jpg, jpeg, webp and png"
              onHide={() => setallowJpg(false)}
              actionButton="Go back"
              fromPayment="true"
              action={() => setallowJpg(false)}
              processingInfo
            />
          </DialogTitle>

          {!currentStep ? (
            uploadType === 'video' ? (
              <VideoSelect
                setUpdateType={setUpdateType}
                fileInputRef={fileInputRef}
                handleClose={handleClose}
                VideoFile={VideoFile}
                uploadText={uploadText}
                onHide={handleClose}
                setUploadedFile={setUploadedFile}
                hideModal={handleClose}
              />
            ) : uploadType === 'photo' ? (
              chooseAlbumStep === 1 ? (
                  <PhotoSelect
                    MAX_PHOTOS={MAX_PHOTOS}
                  fileInputRef={fileInputRef}
                  PhotoFile={PhotoFile}
                  uploadText={uploadText}
                  />
              ) : chooseAlbumStep === 2 ? (
                <PhotoPreview
                  photoFile={photoFile}
                  photoUpload={PhotoFile}
                  removePhoto={removePhoto}
                  fileInputRef={fileInputRef}
                  handleClose={handleClose}
                  setChooseAlbumStep={setChooseAlbumStep}
                  fromContentLayout={isAnExistingAlbum}
                  uploadPhoto={uploadPhotoToExistingAlbum}
                  setaddMorePhoto={setaddMorePhoto}
                  addMorePhoto={addMorePhoto}
                  getRandomImages={getRandomImages}
                  addingPhotos={addingPhotos}
                  uploadText={uploadText}
                  commonText={commonText}
                />
              ) : chooseAlbumStep === 3 ? (
                <AlbumDetails
                  spinerSmall={spinerSmall}
                  loader={loader}
                  setChooseAlbumStep={setChooseAlbumStep}
                  setAlbumTitle={setAlbumTitle}
                  albumTitle={albumTitle}
                  albumDescription={albumDescription}
                  setAlbumDescription={setAlbumDescription}
                  customAlbumThumbnails={customAlbumThumbnails}
                  defaultAlbumThumbnail={defaultAlbumThumbnail}
                  setDefaultAlbumThumbnail={setDefaultAlbumThumbnail}
                  generateCustomThumbnail={generateCustomThumbnail}
                  albumThumbnails={albumThumbnails}
                  addOrEditAlbum={addOrEditAlbum}
                  albumSize={albumSize}
                  albumPhotoCount={albumPhotoCount}
                  uploadText={uploadText}
                  commonText={commonText}
                />
              ) : chooseAlbumStep === 4 ? (
                <AlbumSummary
                  videoVisibilityOptions={videoVisibilityOptions}
                  albumVisibility={albumVisibility}
                  setAlbumVisibility={setAlbumVisibility}
                  selectGroup={selectGroup}
                  settextOfUpload={settextOfUpload}
                  textOfUpload={textOfUpload}
                  videoGroup={videoGroup}
                  publishAlbum={publishAlbum}
                  defaultAlbumThumbnail={defaultAlbumThumbnail}
                  albumSize={albumSize}
                  albumPhotoCount={albumPhotoCount}
                  addingPhotos={addingPhotos}
                  uploadText={uploadText}
                  loading={loading}
                  commonText={commonText}
                  visibilityText={visibilityText}
                  setChooseAlbumStep={setChooseAlbumStep}
                  chooseAlbumStep={chooseAlbumStep}
                />
              ) : null
            ) : (
              <ChooseWhatUpload
                setUpdateType={setUpdateType}
                setChooseAlbumStep={setChooseAlbumStep}
                getAlbums={getAlbumsList}
                albumList={albumList}
                gettingAlbums={gettingAlbumList}
                setExistingAlbum={setExistingAlbum}
                chooseExistingAlbum={chooseExistingAlbum}
                updateAnExistingAlbum={updateAnExistingAlbum}
                uploadText={uploadText}
                commonText={commonText}
              />
            )
          ) : currentStep === 1 ? (
            <VideoDetails
              failedToGenerate={failedToGenerate && blobFile?.length === 0}
              isThumbnailCreationCompleteFully={
                isThumbnailCreationCompleteFully
              }
              blobFile={blobFile}
              buttonDisabled={buttonDisabled}
              modalType="upload"
              allowJpg={allowJpg}
              setallowJpg={setallowJpg}
              uploadText={uploadText}
              videoTitle={videoTitle}
              setVideoTitle={setVideoTitle}
              draftApiStatus={draftApiStatus}
              videoDescription={videoDescription}
              setVideoDescription={setVideoDescription}
              customVideoThumbnails={customVideoThumbnails}
              setDefaultVideoThumbnail={setDefaultVideoThumbnail}
              isThumbnailCreationFailed={isThumbnailCreationFailed}
              setThumbnailType={setThumbnailType}
              videoThumbnails={videoThumbnails}
              thumbnailGenerationStatus={thumbnailGenerationStatus}
              videoFile={videoFile}
              uploadingVideo={uploadingVideo}
              defaultVideoThumbnail={defaultVideoThumbnail}
              videoDetails={videoDetails}
              videoIsUploaded={videoIsUploaded}
              uploadedData={uploadedData}
              moveToNextStep={moveToNextStep}
              uploadVideo={uploadVideo}
              commonText={commonText}
              conversionStart={conversionStart}
              percentage={percentagee}
              setUploadChecking={setUploadChecking}
              handleSaveToDraft={handleSaveToDraft}
              filename={videoDetails.name}
              videoVisibility={videoVisibility}
            />
          ) : currentStep === 2 ? (
            <>
              <UpdateCategoryPlaylist
                buttonDisabled={buttonDisabled}
                conversionStatus={conversionStatus}
                draftApiStatus={draftApiStatus}
                uploadedData={uploadedData}
                setUploadedData={(data) => setUploadedData(data)}
                moveToNextStep={moveToNextStep}
                moveToPreviousStep={moveToPreviousStep}
                currentStep={currentStep}
                videoID={videoID}
                conversionStart={conversionStart}
                uploadText={uploadText}
                commonText={commonText}
                percentage={percentagee}
                uploadChecking={uploadChecking}
                handleSaveToDraft={handleSaveToDraft}
                videoTitle={videoTitle}
                defaultVideoThumbnail={defaultVideoThumbnail}
                videoVisibility={videoVisibility}
              />
            </>
          ) : currentStep === 3 ? (
            <VideoSummary
              buttonDisabled={buttonDisabled}
              modalType="upload"
              draftApiStatus={draftApiStatus}
              setVideoVisibility={setVideoVisibility}
              videoVisibility={videoVisibility}
              defaultVideoThumbnail={defaultVideoThumbnail}
              videoDetails={videoDetails}
              moveToPreviousStep={moveToPreviousStep}
              updateVisibility={updateVisibility}
              videoVisibilityOptions={videoVisibilityOptions}
              videoGroup={videoGroup}
              videoTitle={videoTitle || videoDetails.name}
              isThumbnailCreationFailed={isThumbnailCreationFailed}
              selectGroup={selectGroup}
              uploadedData={uploadedData}
              conversionStart={conversionStart}
              percentage={percentagee}
              handleSaveToDraft={handleSaveToDraft}
            />
          ) : null}
        </div>
      </Fade>
    </>
  );
};
export default Modal;
